import type {
    IProductSizeInsight,
    IProductSizeInsightResponseProduct,
    IProductSizes,
} from "types/insights/product-size-insight";

export class SizeInsights implements IProductSizeInsight {
    constructor(sizeInsights: IProductSizeInsightResponseProduct) {
        this.productId = sizeInsights.product_id;
        this.sizes = sizeInsights.sizes.map((size) => ({
            size: size.name,
            value: size.percentage.this_year * 100,
        }));
    }

    productId: string;
    sizes: IProductSizes[];
}
